class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.chipLinks = this.querySelector('.chip-links').querySelectorAll('.chip-link');
    this.chipContents = this.querySelector('.chip-contents').querySelectorAll('.chip-content');
    this.chipLinks.forEach(chipLink => {
      chipLink.classList.remove('active');
      chipLink.addEventListener('click', this.onChipLinkClick.bind(this));
    })
    this.chipLinks[0].classList.add('active');

    this.chipContents.forEach(chipContent => {
      chipContent.classList.remove('active');
    })
    this.chipContents[0].classList.add('active');
  }


  onChipLinkClick(event) {
    this.chipLinks.forEach(chipLink => {
      chipLink.classList.remove('active');
    })
    event.target.classList.add('active');

    var activeClass = '';

    event.target.classList.forEach(chipLinkClass => {
      if (chipLinkClass.includes('tab')) {
        activeClass = chipLinkClass.split('-')[0];
      }
    })

    this.chipContents?.forEach(chipContent => {
      chipContent.classList.remove('active');
    })
    this.querySelector(`.${activeClass}-content`).classList.add('active');
  }
}

customElements.define('size-guide', SizeGuide);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

setUpSizeUnits();

function setUpSizeUnits(){
  let units = []
  document.querySelectorAll("size-guide table td span")?.forEach(size =>{
    const unit = size.dataset.unit;
    if (unit != undefined && !units.includes(unit)){
      units.push(unit)
    }
  })
}